// extracted by mini-css-extract-plugin
module.exports = {"card":"index_card__T8TZa","wrapperInputNumber":"index_wrapperInputNumber__3lyad"};